import { surveyLocalization } from "../surveyStrings";

export var ukrainianSurveyStrings = {
  pagePrevText: "Назад",
  pageNextText: "Далі",
  completeText: "Завершити",
  startSurveyText: "Почати",
  otherItemText: "Інше (будь ласка, опишіть)",
  noneItemText: "Жоден",
  selectAllItemText: "Вибрати все",
  progressText: "Сторінка {0} з {1}",
  questionsProgressText: "Відповіли на {0}/{1} питань",
  emptySurvey: "Немає жодного питання.",
  completingSurvey: "Дякуємо Вам за заповнення анкети!",
  completingSurveyBefore:
    "Ви вже проходили це опитування.",
  loadingSurvey: "Завантаження опитування...",
  optionsCaption: "Вибрати...",
  value: "значення",
  requiredError: "Будь ласка, дайте відповідь.",
  requiredErrorInPanel: "Будь ласка, дайте відповідь хоча б на одне питання.",
  requiredInAllRowsError: "Будь ласка, дайте відповідь на питання в кожному рядку.",
  numericError: "Відповідь повинна бути числом.",
  textMinLength: "Будь ласка введіть більше {0} символів.",
  textMaxLength: "Будь ласка введіть менше {0} символів.",
  textMinMaxLength: "Будь ласка введіть більше {0} и менше {1} символів.",
  minRowCountError: "Будь ласка, заповніть не менше {0} рядків.",
  minSelectError: "Будь ласка, виберіть хоча б {0} варіантів.",
  maxSelectError: "Будь ласка, виберіть не більше {0} варіантів.",
  numericMinMax:
    "'{0}' повинно бути не менше ніж {1}, і не більше ніж {2}",
  numericMin: "'{0}' повинно бути не менше ніж {1}",
  numericMax: "'{0}' повинно бути не більше ніж {1}",
  invalidEmail: "Будь ласка, введіть дійсну адресу електронної пошти.",
  invalidExpression: "Вираз {0} повинен повертати 'true'.",
  urlRequestError: "Запит повернув помилку '{0}'. {1}",
  urlGetChoicesError:
    "Відповідь на запит повернулась порожньою або властивіть 'path' вказано невірно",
  exceedMaxSize: "Розмір файлу не повинен перевищувати {0}.",
  otherRequiredError: "Будь ласка, введіть дані в поле 'Інше'",
  uploadingFile:
    "Ваш файл завантажується. Зачекайте декілька секунд і спробуйте знову.",
  loadingFile: "Завантаження...",
  chooseFile: "Виберіть файл(и)...",
  noFileChosen: "Файл не вибрано",
  confirmDelete: "Ви хочете видалити запис?",
  keyDuplicationError: "Це значення повинно бути унікальним.",
  addColumn: "Додати колонку",
  addRow: "Додати рядок",
  removeRow: "Видалити",
  addPanel: "Додати нову",
  removePanel: "Видалити",
  choices_Item: "Варіант",
  matrix_column: "Колонка",
  matrix_row: "Рядок",
  savingData: "Результати зберігаються на сервер...",
  savingDataError: "Відбулася помилка, результат не був збережений.",
  savingDataSuccess: "Резвультат успішно збережений!",
  saveAgainButton: "Спробувати знову",
  timerMin: "хв",
  timerSec: "сек",
  timerSpentAll: "Ви витратили {0} на цій сторінці і {1} загалом.",
  timerSpentPage: "Ви витратили {0} на цій сторінці.",
  timerSpentSurvey: "Ви витратили {0} протягом тесту.",
  timerLimitAll:
    "Ви витратили {0} з {1} на цій сторінці і {2} з {3} для всього тесту.",
  timerLimitPage: "Ви витратили {0} з {1} на цій сторінці.",
  timerLimitSurvey: "Ви витратили {0} з {1} для всього тесту.",
  cleanCaption: "Очистити",
  clearCaption: "Очистити",
  removeFileCaption: "Видалити файл"
};

surveyLocalization.locales["ua"] = ukrainianSurveyStrings;
surveyLocalization.localeNames["ua"] = "українська";



// WEBPACK FOOTER //
// ./src/localization/ukrainian.ts